/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityDataDto } from '../../models/facility-data-dto';

export interface GetFacilityData$Params {
  facilityGroupId: number;
}

export function getFacilityData(http: HttpClient, rootUrl: string, params: GetFacilityData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FacilityDataDto>>> {
  const rb = new RequestBuilder(rootUrl, getFacilityData.PATH, 'get');
  if (params) {
    rb.path('facilityGroupId', params.facilityGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FacilityDataDto>>;
    })
  );
}

getFacilityData.PATH = '/api/facilitygroup/{facilityGroupId}/harvestfacility';
